// @flow
import React from 'react';

import { createAuthentificationUpdateOeuvre, updateAuthentification } from 'Api';
import EnchereForm from 'pages/Avila/Authentification/Form'

import FormModal from './FormModal'

type Props = {
    oeuvreid: string,
    onClose: any => any,
    actions: Array<any>,
    data: any,
    onSave: any => any
}
export default ({
    onClose,
    actions = [],
    data,
    oeuvre,
    oeuvreid,
    onSave = () => {}
}: Props) => {

    return (
        <FormModal
            title="Authentification"
            data={data}
            onClose={onClose}
            FormComponent={EnchereForm}

            onSave={onSave}
            updateMethod={({ data }) => updateAuthentification({ oeuvreid, data })}
            createMethod={({ data }) => createAuthentificationUpdateOeuvre({ oeuvre, data })}
        />
    )
}